/* FDA 23 Sep: storefront helpers. 1) Keeps html.fda-cart-has-items in step with the cart so the CHECKOUT button on
   product cards (snippets/card-product.liquid, .fda-card-hover) appears once something is in the cart, like the old
   site. 2) Leaves room for Shopify's staff preview bar (second block below). 3) Removing a Build a Box line in the
   cart drawer removes every treat in that box (third block). */
(function () {
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  function set(count) {
    document.documentElement.classList.toggle('fda-cart-has-items', count > 0);
  }
  function refresh() {
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { set(c.item_count || 0); })
      .catch(function () {});
  }
  document.addEventListener('DOMContentLoaded', function () {
    refresh();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () { refresh(); });
    }
  });
  document.addEventListener('fda:cart-changed', refresh);
})();

/* FDA 23 Sep: Shopify's preview bar (#PBarNextFrameWrapper) only shows for logged-in staff. It is fixed to the
   bottom of the window and covered the cart drawer's Checkout button in Dan's tests. Its height goes into
   --fda-pbar-h so the drawer leaves room for it (fda-brand.css). Customers never get the bar, so for them it stays 0. */
(function () {
  var watching = null;
  function measure() {
    var bar = document.getElementById('PBarNextFrameWrapper');
    var h = bar ? Math.round(bar.getBoundingClientRect().height) : 0;
    document.documentElement.style.setProperty('--fda-pbar-h', h + 'px');
    if (bar && !watching && typeof ResizeObserver === 'function') {
      watching = new ResizeObserver(measure);
      watching.observe(bar);
    }
    return !!bar;
  }
  function start() {
    if (measure()) return;
    var mo = new MutationObserver(function () {
      if (measure()) mo.disconnect();
    });
    mo.observe(document.body, { childList: true });
    setTimeout(function () { mo.disconnect(); }, 20000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

/* FDA 23 Sep (Jed): in the cart drawer the Build a Box is its own $0 line with the treats listed under it. Removing
   that line used to leave the treats behind. snippets/cart-drawer.liquid gives the box line's <cart-remove-button>
   data-fda-box-keys (its own key plus every treat's key); this capture listener runs before Dawn's handler, sets all
   of them to 0 in one /cart/update.js call and re-renders the drawer the way Dawn does. The cart page has its own box
   row remover (sections/main-cart-items.liquid, fda-box-remove). */
(function () {
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  document.addEventListener(
    'click',
    function (event) {
      var remover = event.target.closest && event.target.closest('cart-remove-button[data-fda-box-keys]');
      if (!remover) return;
      event.preventDefault();
      event.stopImmediatePropagation();

      var keys = (remover.dataset.fdaBoxKeys || '').split('|').filter(Boolean);
      if (!keys.length) return;
      var items = remover.closest('cart-drawer-items') || remover.closest('cart-items');
      var sections = items && typeof items.getSectionsToRender === 'function' ? items.getSectionsToRender() : [];
      if (items && typeof items.enableLoading === 'function') items.enableLoading(remover.dataset.index);

      var updates = {};
      keys.forEach(function (key) { updates[key] = 0; });

      fetch(root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          updates: updates,
          sections: sections.map(function (section) { return section.section; }),
          sections_url: window.location.pathname
        })
      })
        .then(function (response) { return response.json(); })
        .then(function (state) {
          if (!state || state.status || !state.sections) throw new Error('cart update failed');
          var empty = state.item_count === 0;
          var drawer = document.querySelector('cart-drawer');
          if (drawer) drawer.classList.toggle('is-empty', empty);
          if (items) items.classList.toggle('is-empty', empty);
          sections.forEach(function (section) {
            var host = document.getElementById(section.id);
            var html = state.sections[section.section];
            if (!host || !html) return;
            var target = host.querySelector(section.selector) || host;
            target.innerHTML = items.getSectionInnerHTML(html, section.selector);
          });
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'fda-box-remove', cartData: state });
          }
          document.dispatchEvent(new CustomEvent('fda:cart-changed'));
        })
        .catch(function () {
          window.location.reload();
        });
    },
    true
  );
})();
